/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Contact API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Property to sort contacts by
 * @export
 * @enum {string}
 */
export enum SortByType {
    LastContactDate = 'LAST_CONTACT_DATE',
    LastName = 'LAST_NAME',
    FirstName = 'FIRST_NAME',
    Popularity = 'POPULARITY'
}

export function SortByTypeFromJSON(json: any): SortByType {
    return SortByTypeFromJSONTyped(json, false);
}

export function SortByTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortByType {
    return json as SortByType;
}

export function SortByTypeToJSON(value?: SortByType | null): any {
    return value as any;
}

